  /* 
  🔒 LOCKED PRICE OVERLAY LOGIC — DO NOT REMOVE
  Shopify hydration-safe wrapper ensures this block persists.
  Last verified working: Aug 10, 2026
*/
document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("core-options-root");
  const readout = document.getElementById("core-readout");
  const btnWrapper = document.querySelector(".product-form__buttons");

  if (!root || !btnWrapper) {
    if (readout) readout.textContent = "ERROR: Missing root or button wrapper";
    return;
  }

  // ⭐ Pull fee from Core Deposit <small>
  let coreFeeValue = "";
  const coreDepositEl = Array.from(document.querySelectorAll("small"))
    .find(el => el.textContent.includes("Core Deposit"));

  if (coreDepositEl) {
    const match = coreDepositEl.textContent.match(/\$([\d.,]+)/);
    if (match && match[1]) {
      coreFeeValue = match[1].replace(",", "").trim();
    }
  }

  // Fallback
  if (!coreFeeValue) {
    let rawFee = root.dataset.coreFee || "";
    coreFeeValue = rawFee.replace("$", "").replace("USD", "").replace(",", "").trim();
  }
  /* 
  🔒 LOCKED PRICE OVERLAY LOGIC — DO NOT REMOVE
  Shopify hydration-safe wrapper ensures this block persists.
  Last verified working: Aug 10, 2026
*/
// ⭐ Update displayed total price dynamically DO NOT MODIFY
const totalPriceEl = document.getElementById("calculated-total-price");
const basePriceEl = document.querySelector(".price-item--regular");

if (totalPriceEl && basePriceEl) {
  const basePrice = parseFloat(basePriceEl.textContent.replace(/[$,]/g, "")) || 0;
  const coreFee = parseFloat(coreFeeValue) || 0;
  const total = basePrice + coreFee;

  totalPriceEl.textContent = `💰 Total Price: $${total.toFixed(2)} USD`;
  totalPriceEl.classList.add("updated");
}

  const productTitle = root.dataset.title || "";

  if (readout) {
    readout.textContent = `READY\nCore fee: ${coreFeeValue}\nProduct: ${productTitle}`;
  }

  btnWrapper.addEventListener("click", async () => {
    if (readout) readout.textContent = "CLICKED — Adding main product...";

    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) {
      if (readout) readout.textContent = "ERROR: Main variant input not found";
      return;
    }

    const mainVariantId = variantInput.value;

    // ⭐ Add main product
    const mainRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: mainVariantId, quantity: 1 })
    });
    const mainJson = await mainRes.json();

    if (readout) {
      readout.textContent += `\nMAIN PRODUCT RESPONSE:\n${JSON.stringify(mainJson, null, 2)}`;
    }

    // ⭐ FINAL CHANGE — If core fee is missing OR zero → skip core fee entirely
    if (
      !coreFeeValue ||
      coreFeeValue.trim() === "" ||
      coreFeeValue === "0" ||
      coreFeeValue === "0.00"
    ) {
      if (readout) {
        readout.textContent += `\nNo core fee detected — skipping core fee add.\nRedirecting to cart...`;
      }
      window.location.href = "/cart";
      return;
    }

    // ⭐ Load core-fee.js
    if (readout) readout.textContent += `\nLoading core-fee.js...`;
    const coreProduct = await fetch("/products/core-fee.js").then(r => r.json());

    if (readout) {
      readout.textContent += `\nLoaded ${coreProduct.variants.length} core fee variants.`;
    }

    // ⭐ Convert fee to cents
    const feeInCents = Number(coreFeeValue) * 100;

    // ⭐ Find variant by price
    const feeVariant = coreProduct.variants.find(v => v.price === feeInCents);

    if (!feeVariant) {
      if (readout) readout.textContent += `\nERROR: No variant found for fee ${coreFeeValue}.`;
      return;
    }

    const feeVariantId = feeVariant.id;

    if (readout) {
      readout.textContent += `\nMatched Variant Price: ${feeInCents}`;
      readout.textContent += `\nVariant ID: ${feeVariantId}`;
    }

    // ⭐ Prevent duplicate core fee ONLY for same product name
    const cart = await fetch("/cart.js").then(r => r.json());
    const coreFeeVariantIds = coreProduct.variants.map(v => v.id);

    const coreAlreadyInCart = cart.items.some(item =>
      coreFeeVariantIds.includes(item.variant_id) &&
      item.properties?.["Linked Product"] === productTitle
    );

    if (coreAlreadyInCart) {
      if (readout) {
        readout.textContent += `\nCore fee already in cart for this product — skipping duplicate add.\nRedirecting to cart...`;
      }
      window.location.href = "/cart";
      return;
    }

    // ⭐ Add correct core fee variant
    const coreRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: feeVariantId,
        quantity: 1,
        properties: {
          "Core Fee Amount": coreFeeValue,
          "Displayed Price": `$${coreFeeValue} USD`,
          "Linked Product": productTitle,
          "Matched Variant Price": feeInCents
        }
      })
    });
    const coreJson = await coreRes.json();

    if (readout) {
      readout.textContent += `\nCORE FEE RESPONSE:\n${JSON.stringify(coreJson, null, 2)}\nRedirecting to cart...`;
    }

    window.location.href = "/cart";
  });
});
